import React, { Component } from 'react'
import { connect } from 'react-redux'
import ScrollArea from 'react-scrollbar'
import ReactHtmlParser from 'react-html-parser'
import { Link } from 'react-router-dom'
import Thumb from '../components/Thumb'
import { setHTML } from '../helpers/helpers'
import { DEFAULT_CUSTOM_POST } from '../reducers/customposts'

class Popup extends Component {
    render() {
        const { post } = this.props
        return (
            <div className="popup">
                <div className="grid-container full">
                    <div className="grid-x">
                        <div className="cell medium-4 xlarge-6 feedstyle">
                            <Thumb thumbid={post.featured_media} backgroundImage={true} size="large" />
                        </div>
                        <ScrollArea
                            speed={0.8}
                            className="cell medium-8 xlarge-6"
                            contentClassName="content"
                            horizontal={false}>
                                <h2>{ReactHtmlParser(post.title.rendered)}</h2>
                                {setHTML(post.content.rendered)}
                        </ScrollArea>
                        <Link className="close" to={this.props.match.path.replace(':id','')}><i className="material-icons">close</i></Link>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {
    const klanten = state.customposts['klanten'] || state.customposts[DEFAULT_CUSTOM_POST]
    const taqtici = state.customposts['taqtici'] || state.customposts[DEFAULT_CUSTOM_POST]
    const requestedPost = ( ownProps.location.pathname.indexOf('taqtici')  !== -1 ? taqtici.find(post => post.slug === ownProps.match.params.id) : klanten.find(post => post.slug === ownProps.match.params.id) ) || klanten[0]
    return {
        post: requestedPost,
    }
}

export default connect(mapStateToProps)(Popup)


// WEBPACK FOOTER //
// ./src/pages/Popup.js